/**
 * @ignore
 */
export const environment = {
  production: false,
  vsolServerDomain: 'weeder.dev.wr.management.dtymr.tk',
  vsolServerUrl: 'https://weeder.dev.wr.management.dtymr.tk/VineyardWeb',
  idcsOAuthUrl:
    'https://idcs-1f230b11cce8499f9fbf1b75393c5ea0.identity.oraclecloud.com',
  idcsClientIdAndSecret:
    'MzQ0NTg2MWM0MmE1NGI3N2FiNWJlNGM2ZjExOGE3ZjU6MzM3Yjg2OGEtMTc5Zi00NTA4LTgwNGUtYzc5NmI3Yjc0NjEy',
};
